module.exports = __webpack_public_path__ + "6c4e131873a7527d9448ddaf85f44ca8.png";